import { useState } from "react";
import { toast } from "sonner";
import { Heart, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { login, setToken } from "@/lib/api";

export const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { access_token } = await login(email, password);
      setToken(access_token);
      toast.success("Welcome back!");
      onSuccess();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[var(--surface)]" data-testid="cms-login-page">
      <div className="w-full max-w-md bg-[var(--card)] rounded-2xl p-8 sm:p-10 border border-[var(--border)] shadow-lg">
        <div className="text-center mb-8">
          <Heart className="w-7 h-7 mx-auto text-[var(--gold)]" />
          <h1 className="font-serif text-3xl text-[var(--burgundy)] mt-3">Wedding CMS</h1>
          <p className="text-sm text-[var(--text-muted)] mt-1">Admin sign in</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="cms-login-form">
          <div>
            <Label>Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="mt-1.5" data-testid="login-email-input" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1.5" data-testid="login-password-input" />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-full py-3 text-white font-medium flex items-center justify-center gap-2 transition-all hover:scale-[1.02] disabled:opacity-60"
            style={{ backgroundColor: "var(--gold)" }}
            data-testid="login-submit-button"
          >
            <Lock className="w-4 h-4" /> {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};
